export default {
      id: "quote-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.95404f0a.svg#quote",
      toString: function () {
        return this.url;
      }
    }